import React, { Component, PropTypes } from 'react';
import idx from 'idx';
import sortBy from 'lodash/sortBy';
import isEqual from 'lodash/isEqual';

export default class Masonry extends Component {
  constructor(props) {
    super(props);

    this.init = this.init.bind(this);
    this.destroy = this.destroy.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    this.destroy();
  }

  destroy() {
    if (this.masonry) {
      this.masonry.destroy();
    }
  }

  init() {
    const MasonryLayout = require('masonry-layout');

    this.masonry = new MasonryLayout(".grid", {
      itemSelector: ".grid-item",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
      percentPosition: true,
    });
  }

  componentDidUpdate(prevProps) {
    /* re-init masonry if items have changed */
    if (!isEqual(prevProps.items, this.props.items)) {
      this.destroy();
      this.init();
    }
  }

  render() {
    const { items, gutterWidth } = this.props;
    /* use lowest width among items */
    const sizerWidth = idx(
      sortBy(items, item => parseInt(item.width.replace("%", ""))), _ => _[0].width
    );

    return (
      <div className="masonry">
        <div className="grid hide-for-small-only">
          <div className="grid-sizer" style={{ width: sizerWidth }}/>
          <div className="gutter-sizer" style={{ width: gutterWidth }}/>
          { items.map((item, i) => (
          <div key={i} className="grid-item" style={{ width: item.width }}>
            { item.content }
          </div>
          )) }
        </div>
        {/* don't use masonry layout for mobile */}
        <div className="show-for-small-only">
          { items.map((item, i) => <div key={i}>{ item.content }</div> )}
        </div>
      </div>
    );
  }
}

Masonry.propTypes = {
  items: PropTypes.array.isRequired,
  gutterWidth: PropTypes.string.isRequired,
};
